import type { IconData } from '@stacksjs/iconify-core'

export const pen: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m5.648 12.276l-1.65 1.1l-.415 1.68l1.665-.42l1.104-1.656zM7.1 10.899l.627.627l.091-.032c.937-.334 1.88-1.019 2.824-2.089c1.139-1.29 3.061-3.587 5.757-6.879a.211.211 0 0 0-.297-.297c-3.286 2.693-5.583 4.616-6.881 5.758c-1.076.946-1.76 1.888-2.088 2.819zm-.615 5.486L.843 17.814l1.4-5.671l3.004-2.004Q5.926 8.225 7.9 6.486Q9.88 4.743 14.836.682a2.21 2.21 0 0 1 3.111 3.112q-4.065 4.963-5.804 6.934q-1.734 1.965-3.652 2.65z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default pen
